import { Link } from 'react-router-dom';
import './css/App.css';

function NotFound() {
  return (
    <div className="sectionbody">
      <div className="intro-paragraph-area" style={{ textAlign: 'center', minHeight: '50vh' }}>
        <h1>404 - Page Not Found</h1>
        <p>The page you're looking for doesn't exist.</p>
        <p><Link to="/" className="hyperlink" style={{ textDecoration: 'underline' }}>Go back to Home</Link></p>
      </div>
    </div>
  );
}

export default NotFound;
